export default {
  meta: {
    title: '行业管理',
  },
};
